(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    for (const block of document.querySelectorAll('[data-email-signup-sync-phone]')) {
      const form = block.querySelector('.email-signup__form');

      if (!(form instanceof HTMLFormElement)) {
        continue;
      }

      form.addEventListener('submit', () => {
        const email = form.querySelector('[name="contact[email]"]')?.value?.trim();
        const phone = form.querySelector('[name="contact[phone]"]')?.value?.trim();

        if (!email || !phone || typeof window.klaviyo?.identify !== 'function') {
          return;
        }

        const digits = phone.replace(/\D/g, '');

        if (!digits) {
          return;
        }

        const phone_number = phone.startsWith('+')
          ? `+${digits}`
          : digits.length === 10
            ? `+1${digits}`
            : `+${digits}`;

        window.klaviyo.identify({ email, phone_number });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
